import * as api from "../Api";

export const getInstitutionStats = () => async (dispatch) => {
  try {
    const { data } = await api.getInvestmentInstitutionStats();
    dispatch({ type: "GET_INVESTMENT_INSTITUTION_STATS", payload: data });
  } catch (error) {}
};
